import * as React from 'react';
import YouTube from 'react-youtube';

type YoutubePlayerProps = { videoId: string; onWatched?: () => void };

export const YoutubePlayer: React.FC<YoutubePlayerProps> = ({
  videoId,
  onWatched,
}) => {
  return (
    <YouTube
      videoId={videoId}
      onEnd={onWatched}
      opts={{ width: '100%', height: '100%' }}
      className="tw:size-full"
      iframeClassName="tw:size-full"
    />
  );
};
